
import BlogHeader from './components/BlogHeader';
import BlogList from './components/BlogList';

export default function BlogPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-purple-50 to-indigo-50">
      <BlogHeader />
      <div className="px-4 sm:px-6 lg:px-8 py-8">
        <BlogList />
      </div>
    </div>
  );
}
